/**
 * Dependencies
 */
import http from '../../../../services/HttpService'

/**
 * Reset the module state
 *
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Update the editor's value
 *
 * @param  {Function} options.commit
 * @param  {String} val
 * @return {Promise}
 */
const updateValue = ({ commit }, val) => commit('UPDATE_VALUE', val)

/**
 * Submit a new generated table module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
const submit = ({ commit, dispatch, rootState, state }) => {
    let action = 'domAlt/createComponent'
    let data = getPostData(rootState, state)
    let options = { root: true }
    commit('SET_LOADING')
    commit('RESET_ERROR')
    dispatch(action, data, options)
        .then(res => {
            commit('RESET_LOADING')
            dispatch('dom/newComponent/toggleModal', null, { root: true })
        })
        .catch(() => {
            commit('SET_ERROR')
            commit('RESET_LOADING')
        })
}

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
const getPostData = (rootState, state) => {
    let page = rootState.dom.newComponent.context.page
    let position = rootState.dom.newComponent.context.position
    return {
        type: 'generated-table',
        component: { page: page },
        model: {
            position: position,
            value: {
                key: state.selected,
                selected_options: {},
                resource: 'project'
            }
        }
    }
}

/**
 * Get a list of available tables
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const fetchOptions = ({ commit }) => new Promise((resolve, reject) => {
    http.get('dom/generated-tables/')
        .then(res => {
            commit('SET_OPTIONS', res.data.data)
            resolve()
        })
        .catch(err => reject(err))
})

/**
 * Select an option and persist the component state
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {String} option
 * @return {Promise}
 */
const selectOption = ({ commit, dispatch }, option) => commit('SELECT_OPTION', option)

export default {
    submit,
    resetState,
    updateValue,
    fetchOptions,
    selectOption
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-gen-table/actions.js